const rootActionPath = 'core/ExploreCategories';

export const EXPLORE_CATEGORIES_VIEW = `${rootActionPath}/VIEW`;
